"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNotificationData = exports.NotificationProvider = exports.NotificationContext = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const NotificationContext = exports.NotificationContext = /*#__PURE__*/(0, _react.createContext)({
  notificationData: {
    setNotificationData: () => {}
  }
});
const NotificationProvider = ({
  children
}) => {
  const [data, setNotificationData] = (0, _react.useState)({});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationContext.Provider, {
    value: {
      notificationData: {
        data,
        setNotificationData
      }
    },
    children: children
  });
};
exports.NotificationProvider = NotificationProvider;
const useNotificationData = () => {
  const ctx = (0, _react.useContext)(NotificationContext);
  return {
    context: ctx
  };
};
exports.useNotificationData = useNotificationData;
//# sourceMappingURL=notificationContext.js.map